import { formatDictValue } from './src/main.js'
import DgDict from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgDict.install = function (Vue) {
  Vue.component(DgDict.name, DgDict)
}
export default DgDict

export { DgDict, formatDictValue }
